<template>


<div class="modal fade pt-lg-5" id="setupModal" tabindex="-1" role="dialog" aria-labelledby="setupModal" aria-hidden="true">
  <div class="modal-dialog modal-lg pt-lg-5" role="document">
    <div class="modal-content">
      <div class="modal-body">
        


          <div id="carouselSetupWizard" class="carousel slide" >
            <div class="carousel-inner">
              <div class="carousel-item active text-center">

                <p><img class="matilda" src="images/matilda.svg"></p>
                <p class="lead mb-1">Hi {{ settings.first_name }}, I’m Matilda.</p>
                <p class="lead mb-1">I’m here to get you set up as quickly as possible.</p>
                <p class="lead">Sound good to you?</p>
                <button type="button" class="btn btn-primary" @click="wizardNext">Great! Let's Get Started</button>

              </div>

 

              <div class="carousel-item text-center">
                
                  <p class="lead">Firstly, let's check a few things. I have your company name as:</p>
                  <h5 class="font-weight-bold">{{ settings.company_name }}</h5> 
                  <p class="lead">Is that correct?</p>

                  
                  
                  <button type="button" class="btn btn-secondary" @click="showCompanyName">No</button>
                  <button type="button" class="btn btn-primary" @click="wizardNext">Yes</button>


                  <div class="collapse no-toggle " id="collapseCompanyName">
                    <hr />
                    <h5 class="text-center font-weight-bold">Ok, Please enter your company name below:</h5>
                    <input type="text" class="form-control margin-bottom-20" id="companyName" ref="companyName" placeholder="Company Name" :value="settings.company_name">
                    <div class="messagebox"></div>
                    <p class="text-center pt-3"><button type="button" class="btn btn-primary" @click="saveName">Save and Continue</button></p>
                  </div>

                  <div class="collapse no-toggle" id="collapseCompanyNameContinue">
                    <hr />
                    <p class="text-center"><button type="button" class="btn btn-primary" @click="wizardNext"></span> Continue</button></p>
                  </div>

              </div>


              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Great! </h5>
                  <h5 class="text-center font-weight-bold">Now complete the following details about your company.</h5>

                  <div class="row justify-content-center">

                    <div class="col-6 py-2">
                  
                      <input type="text" class="form-control" id="company_telephone" ref="companyTelephone" placeholder="Company phone number" :value="settings.company_telephone">

                    </div>

                  </div>
                  <div class="row justify-content-center">

                    <div class="col-6 py-2">
                  
                      
                      <input type="email" class="form-control" id="company_email" ref="companyEmail" placeholder="Company email address" :value="settings.company_email">
                      

                    </div>

                  </div>
                  <div class="row justify-content-center">

                    <div class="col-6 py-2">

                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <select class="custom-select rounded-left" id="company_website_prefix" ref="companyWebsitePrefix">
                              <option value="https://" selected>https://</option>
                              <option value="http://">http://</option>
                            </select>
                        </div>
                        <input type="url" class="form-control" id="company_website" ref="companyWebsite" placeholder="Website address" :value="settings.website">
                      </div>

                    </div>

                  </div>
                  <div class="row justify-content-center">

                    <div class="col-6 py-2">
                  
                      <textarea class="form-control" id="company_profile" ref="companyProfile" placeholder="Sum up what your company does in a sentence or two.">{{ settings.company_profile }}</textarea>

                    </div>

                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6">
                      <div class="matilda-chat"><div class="chat-bubble"><span class="lead">This information will appear in the company profile area on the desktop view of your SizzleDecks.</span></div></div>
                    </div>
                  </div>
                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveCompanySettings">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>


              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Please upload your company logo.</h5>

                  <div class="row justify-content-center">

                    <div class="col-4">

                      <company-logo v-if="settings_loaded" input-id="company_logo" name="company_logo" :image="settings.logo" ref="company_logo" :disableLibraryButton="true" uploadButtonText="Upload Logo"></company-logo>

                    </div>

                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6">
                      <div class="matilda-chat"><div class="chat-bubble"><span class="lead">If possible, it's best to use a landscape logo on a white or transparent background.</span></div></div>
                    </div>
                  </div>
                  <div class="row justify-content-center">

                    <div class="col-12">

                      

                      <div class="d-flex flex-row-reverse justify-content-between">
                          <button type="button" class="btn btn-primary"   @click="saveLogo">Next</button>
                          <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                      </div>  

                    </div>
                  </div>

              </div>

              <div class="carousel-item">
                    
                  <div class="form-row">
                    <div class="col col-9 mr-auto ml-auto">
                      <h5 class="text-center font-weight-bold">Thanks. Now to make SizzleDeck your own, you can select up to 3 company colours using the pickers below.</h5>
                    </div>
                  </div>

                  <div class="form-row">
                    
                      <div class="form-group col text-center mt-4 mb-3">
                                                   
                          <company-color-picker v-if="settings_loaded" name="company_accent_color" ref="company_accent_color" :value="settings.accent_color"></company-color-picker>
               
                          
                      </div>
                      <div class="form-group col text-center mt-4 mb-3">
                                                   
                          
                          <company-color-picker v-if="settings_loaded" name="company_secondary_color" ref="company_secondary_color" :value="settings.secondary_color"></company-color-picker>
                          
                          
                      </div>
                      <div class="form-group col text-center mt-4 mb-3">
                                                   
                          <company-color-picker v-if="settings_loaded" name="company_tertiary_color" ref="company_tertiary_color" :value="settings.tertiary_color"></company-color-picker>
                          
                      </div>
                      
                  </div>

                  <div class="row justify-content-center">
                    <div class="col-6 mt-4">
                      <div class="matilda-chat"><div class="chat-bubble"><span class="lead">These will automatically be applied to card headlines, buttons and some card backgrounds.</span></div></div>
                    </div>
                  </div>

 

                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveColors">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>
              <!--
              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Please upload your deck background or choose one from our library.</h5>

                  <div class="row justify-content-center">

                    <div class="col-6">

                      <deck-background input-id="background" name="background" image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAYUlEQVRoge3PsQkAIADAMP//0UHwDz1DqBm6N2OveX5qvB4ABgYGBgYG/ifgesD1gOsB1wOuB1wPuB5wPeB6wPWA6wHXA64HXA+4HnA94HrA9YDrAdcDrgdcD7gecD3gehdGZAsOaCqOMAAAAABJRU5ErkJggg==" ref="background"></deck-background>

                    </div>
                  </div>

                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveBackground">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>
            -->
 
            <!--
              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Finally, please upload a picture of yourself for your profile picture.</h5>

                  <div class="row justify-content-center">

                    <div class="col-6">
                  
                      <profile-image :disableLibraryButton="true" input-id="profile_pic" name="profile_pic" image="/images/default/avatar.png" ref="profile_pic"></profile-image>

                    </div>

                  </div>

                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveProfilePicture">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>
            -->


              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Please upload a company profile image (i.e. a picture of your office or team etc.)</h5>

                  <div class="row justify-content-center">

                    <div class="col-6">
                  
                      <profile-background :disableLibraryButton="true" input-id="profile_background" name="profile_background" image="/images/default/team-work.jpg" ref="profile_background"></profile-background>

                    </div>

                  </div>

                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveProfileBackground">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>


              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Finally, please choose an SMS 'from' name. This is what will appear on the text messages you send.</h5>

                  <div class="row justify-content-center">

                    <div class="col-6">
                  
                      <input type="text" class="form-control margin-bottom-20" id="sms_send_number" ref="smsSendNumber" placeholder="SMS From Name" @keydown="checkKeyDownAlphaNumeric($event)" :value="settings.sms_send_number" maxlength="11">

                    </div>

                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6">
                      <div class="matilda-chat"><div class="chat-bubble"><span class="lead">This may contain up to 11 alphanumeric characters and cannot contain spaces.</span></div></div>
                    </div>
                  </div>
                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveSenderID">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>
              <div class="carousel-item text-center">

                <h5 class="text-center font-weight-bold">All done! Now let’s make a SizzleDeck!</h5>


                <p class="lead">(You can still change your info in Company Settings.)</p>
                <button type="button" class="btn btn-primary" @click="redirectToNewDeck">Great! Let’s Get Started.</button>

              </div>

            </div>
          </div>
          </div>


        
      </div>
    
    </div>
  </div>
</div>

</template>

<script>

import axios from 'axios';
import Noty from 'noty';

export default {

  mounted() {

      var vm = this;

      // Get Defaults / Inital
      axios.get('/deck/defaults').then(response => {

        vm.settings = response.data;

        // Remove http/s prefix 
        if(vm.settings.website){
          vm.settings.website = vm.settings.website.replace('https://','').replace('http://','');
        }

        vm.settings_loaded = true;

        $('.carousel').carousel({
          interval: false,
          wrap: false,
        })
        $('#setupModal').modal({
            backdrop: 'static',
            keyboard: false,
            show: true,
            focus: true
        });

      }).catch(function(error){ console.log('e1'); vm.handleError(error) });


      },
      data: function(){
        return {                
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          settings_loaded: false,
          settings:[],
        }
      },
      methods:{
        wizardNext: function(){
          $('#carouselSetupWizard').carousel('next');
        },
        wizardPrev: function(){
          $('#carouselSetupWizard').carousel('prev');
        },
        showCompanyName: function(){
          $('#collapseCompanyNameContinue').slideUp();
          $('#collapseCompanyName').slideDown();
        },
        showCompanyNameContinue: function(){
          $('#collapseCompanyName').slideUp();
          $('#collapseCompanyNameContinue').slideDown();
        },
        saveName: function(){

          var vm = this;

          axios.post('/setup',{company_name:vm.$refs.companyName.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e2'); vm.handleError(error) });

          
        },
        saveCompanySettings: function(){

          var vm = this;

          axios.post('/setup',{
            telephone:vm.$refs.companyTelephone.value,
            email:vm.$refs.companyEmail.value,
            website:vm.$refs.companyWebsite.value,
            websitePrefix:vm.$refs.companyWebsitePrefix.value,
            profile:vm.$refs.companyProfile.value,
          }).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e3'); vm.handleError(error) });

        },
        saveLogo: function(){
          var vm = this;

          axios.post('/setup',{company_logo:vm.$refs.company_logo.$refs.company_logo.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e3b'); vm.handleError(error) });

        },
        saveColors: function(){

          var vm = this;

          axios.post('/setup',{
            accent_color:vm.$refs.company_accent_color.$refs.company_accent_color.value,
            secondary_color:vm.$refs.company_secondary_color.$refs.company_secondary_color.value,
            tertiary_color:vm.$refs.company_tertiary_color.$refs.company_tertiary_color.value,
            
            // Lets also save the backgrounds...
            background:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAg0lEQVRoQ+3UAREAIAzEMPAvdwJAAA5KcMA3tz0zZ330tg/HayscD7wUVji2ANKxoM93FFY4tgDSsaCOFtJIxxZAOhbUlUYa6dgCSMeCutJIIx1bAOlYUFcaaaRjCyAdC+pKI410bAGkY0FdaaSRji2AdCyoK4000rEFkI4FdaWRrpO+G+bm3T+saXsAAAAASUVORK5CYII=',
            profile_background:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAX0lEQVRoge3PMQ0AMAzAsPLnWRwbjEmZj/zx7O75qXk9AAwMDAwMDPxPwPWA6wHXA64HXA+4HnA94HrA9YDrAdcDrgdcD7gecD3gesD1gOsB1wOuB1wPuB5wPeB6wPUudFDB3gVafbEAAAAASUVORK5CYII='

          }).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e4'); vm.handleError(error) });

        },
        saveBackground: function(){

          var vm = this;

          axios.post('/setup',{background:vm.$refs.background.$refs.background.value,profile_background:vm.$refs.background.$refs.background.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e5'); vm.handleError(error) });

        },
        saveProfileBackground: function(){
          
          var vm = this;

          axios.post('/setup',{profile_background:vm.$refs.profile_background.$refs.profile_background.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e6'); vm.handleError(error) });

        },
        saveProfilePicture: function(){
          
          var vm = this;

          axios.post('/setup',{profile_pic:vm.$refs.profile_pic.$refs.profile_pic.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e7'); vm.handleError(error) });

        },
        saveSenderID: function(){

          var vm = this;

          axios.post('/setup',{sms_send_number:vm.$refs.smsSendNumber.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ console.log('e8'); vm.handleError(error) });

        },
        redirectToNewDeck: function(){
          // Redirect
          window.location.href = '/deck/new';

        },
        handleError: function(error){

            if(error.response.status == '419'){
              this.showLoggedOutNoty();
            }else{
              this.showGeneralErrorNoty();
            }

        },
        showNoty: function(type='warning',message='',timeout=false){
          new Noty({
                    text: message,
                    type: type,
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: timeout
                }).show();
        },
        showGeneralErrorNoty: function(){
          new Noty({
                    text: 'There has been an error. Please <a href="javascript:window.location.reload(true)">refresh this page</a> and try again.',
                    type: 'error',
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: false
                }).show();
        },
        showLoggedOutNoty: function(){
          new Noty({
              text: 'You have been logged out due to inactivity. Please <a href="javascript:window.location.reload(true)">refresh this page</a> to login.',
              type: 'error',
              theme: 'bootstrap-v4',
              layout: 'topCenter',
              timeout: false
          }).show();
        },  
        checkKeyDownAlphaNumeric: function(event) {
          if (!/[a-zA-Z0-9\-]/.test(event.key)) {
            this.ignoredValue = event.key ? event.key : "";
            event.preventDefault();
          }
        }
      }

}
</script>
